import script from "./NewsHtmlContentDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsHtmlContentDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./NewsHtmlContentDisplay.vue?vue&type=style&index=0&id=1c93f2e4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c93f2e4"]])

export default __exports__